import React from 'react';

import { ConfirmationModal } from './components/confirmationModal.jsx';
import { MultiLineTextField } from './components/commonControls.jsx';
import { DiscussionCommentCard } from './components/discussionCard';
import { LoadingScreen } from './components/loadingScreen.jsx';
import * as ToastAlert from './components/toastAlert';
import { Redirect } from 'react-router-dom';
import ajaxFunctions from './ajaxFunctions';
import { Button, Typography } from '@material-ui/core';
import Scroll from 'react-scroll';
import utils from './utils';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import socketIOClient from "socket.io-client";

export default class DiscussionPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            thread: null,
            isLoading: true,
            enableSubmit: true,
            newComment: '',
            commentToDelete: {},
            showDeleteModal: false,
        };
    }

    componentDidMount() {
        const idThread = utils.getParameterByName('idThread', window.location.href);
        const idComment = utils.getParameterByName('idComment', window.location.href);
        const idIncubator = utils.getParameterByName('idIncubator', window.location.href);
        const socket = socketIOClient(window.globals.socketConnection, {transports: ["websocket"]});
        socket.on(`UpdatePortfolio${idIncubator}`, async data => {
            const thread = data ? data.find(cur => cur.idCardComment == idThread) : null;
            if(thread) this.setState({thread});
          });        
        Promise.all([
            ajaxFunctions.getIncubatorOwnerIds(idIncubator),            // Used for sponsor comment coloring 
            ajaxFunctions.getIncubatorThread(idThread, idIncubator),    // Used to check Incubator visibility per user (as opposed to getting thread w/ no incubator ID)
        ]).then(data => {
            this.setState({
                isLoading: false,
                owners: data[0],
                thread: data[1],
            }, () => {
                if (idComment) {
                    Scroll.Events.scrollEvent.register('end', (to, element) => {
                        element.className += ' scroll-reached';
                    });
                    Scroll.scroller.scrollTo(`comment-${idComment}`, {
                        smooth: true,
                        offset: -80,
                    });
                }
            });
        }).catch(err => {
            ToastAlert.error(err);
            this.setState({ isLoading: false });
        });
    }

    componentWillUnmount() {
        Scroll.Events.scrollEvent.remove('end');
    }

    async handleEditComment(comment, text) {
        const { idParentComment, idCardComment, idPortfolio } = comment;
        await ajaxFunctions.editPortfolioComment(idCardComment, idPortfolio, text, idParentComment, idPortfolio);
    }

    async handleDeleteComment(comment) {
        const { idParentComment, idCardComment, idPortfolio, childComments = [] } = comment;
        await ajaxFunctions.deletePortfolioComment(idCardComment, idPortfolio, childComments.length, idParentComment);
    }

    async handleLikeComment(comment) {
        const { idCardComment, idParentComment, idPortfolio } = comment;
        try {
            await ajaxFunctions.likePortfolioComment(idCardComment, idPortfolio, idParentComment);
        } catch (err) {
            ToastAlert.error(err);
        }
    }
    
    async handleDisableComment(comment) {
        try {
            const { idCardComment, idPortfolio, isDisabled } = comment;
            await ajaxFunctions.disablePortfolioComment(idCardComment, idPortfolio, isDisabled);
        } catch (err) {
            ToastAlert.error(err);
        }
    }

    checkIncubatorOwners(idToCheck) {
        const { owners } = this.state;
        return owners.find(owner => owner.idUser == idToCheck);
    }

    handleKeypress(event) {
        this.setState({ newComment: event.target.value });
    }
    
    handleSubmitComment() {
        const { newComment, thread } = this.state;
        let usersToNotify = new Set();
        thread.childComments.forEach(c => {
            if (c.user.idUser !== parseInt(window.globals.idUser)) {
                usersToNotify.add(c.user.idUser);
            }
        });

        if (thread.user.idUser !== parseInt(window.globals.idUser)) {
            usersToNotify.add(thread.user.idUser);
        }

        this.setState({ enableSubmit: false });
        ajaxFunctions.createPortfolioComment(thread.idCardComment, newComment, thread.idPortfolio).then(c => {
            if (usersToNotify.size > 0) {
                ajaxFunctions.notifyCommenters(
                    thread.idPortfolio, 
                    thread.idCardComment, 
                    c.idCardComment, 
                    [...usersToNotify]
                );
            }
            const scroll = Scroll.animateScroll;
            scroll.scrollToBottom();
            ToastAlert.success('Your discussion comment has been submitted!');
            this.setState({ newComment: '', enableSubmit: true });
        });
    }

    render() {
        const { isLoading, thread, enableSubmit, showDeleteModal, commentToDelete } = this.state;
        const idIncubator = utils.getParameterByName('idIncubator', window.location.href);

        let eventHandlers = {
            onLike: comment => this.handleLikeComment(comment),
            onEdit: (comment, text) => this.handleEditComment(comment, text),
        };

        if (!thread) {
            return isLoading 
                ? <LoadingScreen /> 
                : <Redirect to='/' />;
        }

        return (
            <div className='discussion-page'>
                <h1>{thread.title}</h1>
                <div className='discussion-comments'>
                    <DiscussionCommentCard
                        isTopic
                        isSponsor={idUser => this.checkIncubatorOwners(idUser)}
                        isOwner={idUser => this.checkIncubatorOwners(idUser)}
                        comment={thread}
                        eventHandlers={{
                            ...eventHandlers,
                            onDisable: comment => this.handleDisableComment(comment)
                        }}
                    />
                    {thread.childComments && thread.childComments.map(comment => (
                        <DiscussionCommentCard
                            isSponsor={idUser => this.checkIncubatorOwners(idUser)}
                            isOwner={idUser => this.checkIncubatorOwners(idUser)}
                            comment={comment}
                            key={comment.idCardComment}
                            eventHandlers={{
                                ...eventHandlers,
                                onDelete: comment => this.setState({ showDeleteModal: true, commentToDelete: comment }),
                            }}
                        />
                    ))}
                </div>
                <div className='comment-submission'>
                    {thread.isDisabled ? (
                        <div>
                        <Typography variant='h6'>
                            Commenting has been disabled.
                        </Typography>
                        <Button 
                                startIcon={<FontAwesomeIcon icon={[`far`, 'arrow-left']} />}
                                onClick={() => window.location = `/incubator?idIncubator=${idIncubator}&initialTab=discussion`} 
                                variant='contained' 
                                color='primary' 
                            >
                                Return to Incubator
                            </Button>
                        </div>
                    ) : (
                        <>
                            <MultiLineTextField
                                data={this.state.newComment}
                                onChange={event => this.handleKeypress(event)}
                                dataField= 'newComment'
                                placeholder='New Comment'
                                maxLength={1000}
                            />
                            <Button 
                                onClick={() => this.handleSubmitComment()}
                                variant='contained'
                                color='primary'
                                disabled={
                                    thread.isDisabled 
                                    || this.state.newComment.trim() === '' 
                                    || !enableSubmit
                                }
                            >
                                Submit
                            </Button>
                            <Button 
                                startIcon={<FontAwesomeIcon icon={[`far`, 'arrow-left']} />}
                                onClick={() => window.location = `/incubator?idIncubator=${idIncubator}&initialTab=discussion`} 
                                style={{float: 'right'}} 
                                variant='contained' 
                                color='primary' 
                            >
                                Return to Incubator
                            </Button>
                        </>
                    )}
                </div>
                <ConfirmationModal
                    show={showDeleteModal}
                    closeFunction={() => this.setState({ showDeleteModal: false })}
                    confirmFunction={() => this.handleDeleteComment(commentToDelete)}
                    contentText='Are you sure that you want to delete this comment? This action is irreversible.'
                    confirmText='Delete'
                />
            </div>
        );
    }
}